import React, { FC, memo } from 'react'
import { IonHeader } from '@ionic/react'
import './index.scss'

// props
interface IProps {
  title: string;
  onClose: () => void;
}

const ModalHeader: FC<IProps> = ({ title, onClose }) => {
  return (
    <IonHeader className='handtop-modal-header'>
      <span>{title}</span>
      <i className='iconfont icon-close' data-cypid='modalHeaderClose' onClick={onClose}></i>
    </IonHeader>
  )
}

export default memo(ModalHeader)
